<h2 mat-dialog-title>INFORMATIVA PRIVACY PARTECIPANTI A CORSI ONLINE</h2>
<mat-dialog-content
	#privacyContent
	class="privacy-content"
	tabindex="0"
	(scroll)="onPrivacyScroll($event)"
>
	<p>
		Nel rispetto di quanto disposto dal Regolamento (UE) 2016/679 sulla Protezione dei Dati Personali, ai sensi degli artt. 12, 13 e 14, il presente documento
		ha lo scopo di fornire tutte le informazioni necessarie relative al trattamento dei dati personali dei signori partecipanti al corso online.
	</p>
	<h5>Titolari del Trattamento</h5>
	<p>Il titolare del trattamento dei dati personali è Key Skills S.r.l. con C.F. e P.IVA 12952040967.</p>
	<h5>Finalità del Trattamento</h5>
	<p>
		I dati ricevuti saranno trattati per le seguenti finalità: Gestione di tutte le attività correlate all’organizzazione e all’erogazione del corso al fine di
		consentire ai soggetti interessati la partecipazione, l’assistenza e l’attestazione di frequenza (tracciamento accessi per verifica della frequenza,
		rilascio attestati di partecipazione, ecc..) Il trattamento dei dati si fonda sul principio espresso dall’ Art. 6 del Regolamento Europeo sulla protezione
		dei dati personali, secondo il quale il trattamento di dati personali è lecito se necessario all’esecuzione del servizio richiesto dal Soggetto Interessato.
		Il conferimento dei dati, per tali finalità, risulta necessario per soddisfare la Sua richiesta di iscrizione e partecipazione al corso.
	</p>
	<h5>Tipologia dei dati personali raccolti</h5>
	<p>
		I dati personali raccolti tramite il modulo apposito riguardano precisamente i dati anagrafici e relativi all’attività lavorativa svolta dai soggetti
		iscritti (nominativo, indirizzo e-mail, ruolo e mansione ricoperta dal soggetto interessato presso la sua organizzazione per rilascio dell’attestato di
		frequenza con i requisiti e i contenuti di legge). I Titolari non raccolgono deliberatamente alcuna informazione appartenente alla categoria di “dati
		particolari”.
	</p>
	<h5>Modalità di Trattamento</h5>
	<p>
		Per trattamento di dati personali si intende la loro raccolta, registrazione, organizzazione, conservazione, elaborazione, modificazione, selezione,
		estrazione, raffronto, utilizzo, interconnessione, blocco, comunicazione, diffusione, cancellazione e distruzione, ovvero la combinazione di due o più di
		tali operazioni, anche attraverso strumenti automatizzati atti a memorizzare, gestire e trasmettere i dati stessi, utilizzando strumenti idonei a garantire
		la sicurezza e la riservatezza. Per quanto attiene la sicurezza, comunichiamo che la banca dati è accessibile solo da parte del personale autorizzato dal
		Titolare, così come le relative operazioni sopra descritte e che il trattamento dei Vostri dati avverrà potrà essere effettuato attraverso mezzi elettronici
		o automatizzati ed attraverso mezzi non automatizzati (archivi cartacei), forniti entrambi di adeguate misure di sicurezza, così come previste dal
		Regolamento (UE) 2016/679 sulla Protezione dei Dati Personali, per prevenire la perdita dei dati, gli usi illeciti o non corretti e gli accessi non
		autorizzati. I dati raccolti non verranno utilizzati in contesti o per usi e/o fini diversi da quelli sopra indicati o che possano, in qualsiasi modo,
		compromettere i diritti e le libertà dei soggetti interessati. Comunicazione dei dati a terzi Fatte salve eventuali comunicazioni per adempiere ad obblighi
		di legge, i Titolari comunicheranno i dati personali dei signori partecipanti con attenzione solo a fornitori e soggetti terzi selezionati per la
		realizzazione di attività correlate e ausiliarie alle finalità sopra indicate, ed opportunamente autorizzati al trattamento, quali: - Società esterne per la
		gestione della piattaforma e-learning ovvero delle banche dati e delle reti di telecomunicazioni.
	</p>
	<h5>Trasferimento dei Dati Extra UE</h5>

	<p>I Titolari del trattamento non effettuano direttamente alcun trasferimento dei dati al di fuori dell’Unione Europea.</p>
	<h5>Tempi di conservazione</h5>

	<p>
		I dati personali saranno conservati per il tempo necessario all’esercizio delle operazioni di trattamento in conformità delle finalità anzidette, fermo
		restando la possibilità per il soggetto interessato di esercitare i diritti ad esso riconosciuti dal Regolamento Europeo sulla protezione dei dati
		personali.
	</p>

	<h5>Diritti degli interessati</h5>

	<p>
		Ai sensi del Regolamento Europeo, gli interessati hanno il diritto di chiedere ai Contitolari del trattamento l'accesso ai dati personali (art. 15), la
		rettifica (art. 16), la cancellazione degli stessi o l’oblio (art. 17), la limitazione del trattamento dei dati personali che lo riguardano (art. 18), il
		diritto alla portabilità dei dati (art. 20) o di opporsi al loro trattamento (art. 21), oltre al diritto di non essere sottoposto a una decisione basata
		unicamente sul trattamento automatizzato, compresa la profilazione, che produca effetti giuridici che lo riguardano o che incida allo stesso modo
		significativamente sulla sua persona (art. 22). Qualora il trattamento dei dati personali si basi sul consenso espresso fornito dal soggetto interessato, ai
		sensi dell’art. 7 paragrafo 3 del Regolamento, è riconosciuta la possibilità di recedere in ogni momento dall’iscrizione al servizio di Newsletter ovvero
		revocare il consenso fornito per l’invio di comunicazioni e aggiornamenti per finalità promozionali e commerciali. Le richieste potranno essere esercitate
		nei confronti dei Contitolari del trattamento, scrivendo all’indirizzo e-mail: <span><u>info&#64;keyskills.it</u></span> <br />
		L’interessato ha, altresì, il diritto di proporre reclamo all'autorità di controllo preposta (art. 77 del Regolamento) qualora ritenga che il trattamento
		effettuato da parte del Titolare non sia conforme alle disposizioni di legge sulla protezione dei dati personali.
	</p>
</mat-dialog-content>

@if (!hasReachedEnd()) {
	<div
		id="privacy-scroll-status"
		class="scroll-hint"
		role="status"
		aria-live="polite"
	>
		<i
			class="bi bi-arrow-down-circle"
			aria-hidden="true"
		></i>
		<span>Scorri l’informativa fino in fondo per abilitare “Accetta”</span>
	</div>
}

<mat-dialog-actions class="d-flex gap-3">
	<button
		class="btn btn-primary-ks-white"
		mat-dialog-close
	>
		Esci
	</button>
	<button
		class="btn btn-primary-ks"
		[disabled]="!hasReachedEnd()"
		[mat-dialog-close]="true"
		[attr.aria-describedby]="!hasReachedEnd() ? 'privacy-scroll-status' : null"
		[attr.title]="!hasReachedEnd() ? 'Scorri fino in fondo per accettare' : null"
	>
		Accetta
	</button>
</mat-dialog-actions>
